import { useSelector } from "react-redux";
import MockWorkQ from "../../../mock/MockWorkQ";

export default function WorkQComponentLoading({classes}) {
    // Only show the skeleton mock when we actually have nothing to display.
    // Using `snapshot` alone caused flashing during navigation / failed fetches
    // because `snapshot` is cleared in dispatchWorkQueueNavigationState while
    // `currentpagedata` may still hold the previous queue's rows briefly.
    const showMock = useSelector(state => {
        if (!state.filter.loading) return false
        if (state.filter.snapshotData) return false
        const rowsLen = state.filter.currentpagedata?.data?.length || 0
        return rowsLen === 0
    })
    return <>
        {showMock && <div className={classes.table_body_loading}>
            <MockWorkQ />
        </div>}
    </>
}